import { z } from "zod";
import { ID_PESQUISA } from "./base.ts";
import { ModuloEnum } from "./modulos.ts";
import { StatusFato } from "./pesquisa.ts";

export const PAPEIS = ["admin", "editor", "revisor"] as const;
export const Papel = z.enum(PAPEIS);
export type Papel = z.infer<typeof Papel>;
/** Papel de usuário comum do app (sem acesso ao admin). */
export const PAPEL_USUARIO = "usuario";

export const STATUS_FICHA = ["rascunho", "em_revisao", "aprovada", "arquivada"] as const;
export const StatusFicha = z.enum(STATUS_FICHA);
export type StatusFicha = z.infer<typeof StatusFicha>;

export const FonteInput = z.object({
  id: z.string().regex(ID_PESQUISA, "formato C.F07"),
  sigla: z.string().min(1),
  titulo: z.string().min(1),
  orgao: z.string().nullish(),
  ano: z.string().nullish(),
  versao: z.string().nullish(),
  url: z.url().nullish(),
  doi: z.string().nullish(),
  tipo: z.string().nullish(),
  acesso: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  nota: z.string().nullish(),
  status: z.string().default("verificado"),
  semFato: z.boolean().default(false),
});
export type FonteInput = z.infer<typeof FonteInput>;

export const FatoInput = z.object({
  id: z.string().regex(ID_PESQUISA, "formato E.M01"),
  fonteId: z.string().nullable(),
  afirmacao: z.string().min(1),
  valor: z.string().nullish(),
  unidade: z.string().nullish(),
  localizador: z.string().nullish(),
  citacaoCurta: z.string().nullish(),
  status: StatusFato,
  observacao: z.string().nullish(),
  extra: z.record(z.string(), z.unknown()).default({}),
});
export type FatoInput = z.infer<typeof FatoInput>;

export const FichaInput = z.object({
  modulo: ModuloEnum,
  /** Conteúdo validado pelo schema do módulo. */
  data: z.unknown(),
});
export type FichaInput = z.infer<typeof FichaInput>;

export const Revisao = z.discriminatedUnion("decisao", [
  z.object({ decisao: z.literal("aprovar"), comentario: z.string().optional() }),
  z.object({ decisao: z.literal("devolver"), comentario: z.string().min(3, "explique o que corrigir") }),
]);
export type Revisao = z.infer<typeof Revisao>;

export const Revisor = z.object({ crmv: z.string().regex(/^\d{3,6}$/, "só números"), uf: z.string().length(2).toUpperCase() });

export const AcessoManual = z.object({
  ativo: z.boolean(),
  plano: z.enum(["padrao", "estudante"]).default("padrao"),
  motivo: z.string().min(3),
});

export const MapasManual = z.object({
  ativo: z.boolean(),
  motivo: z.string().min(3),
});
